module.exports = __webpack_public_path__ + "static/media/img49.9a4b6952.jpg";